import {Controller} from '@hotwired/stimulus';
import Swiper, {Autoplay, Navigation, Pagination, EffectFade} from 'swiper';

export default class extends Controller {
	static get targets () {
		return ['currentCount', 'next', 'prev', 'pagination', 'progressGroup', 'pnWrapper'];
	}

	initialize() {
		this._swiper = null;
		this._config = {};
		this._changingSlide = false;
		this._lockedIntoSwiper = false;
		this._watcher = null;
		this._disableScrolLEvent = false;
	}

	connect() {
		this.load();
	}

	disconnect() {
		if (this._swiper) {
			this._swiper.destroy();
			this._swiper = null;
		}
	}
	async load() {
		this._config = this.element.dataset.config ? JSON.parse(this.element.dataset.config) : {};
		const config = this._config;

		config.watchOverflow = true;
		if (config.autoplay) {
			Swiper.use([Autoplay]);
		}

		if (config.effect && config.effect === 'fade') {
			Swiper.use([EffectFade]);
		}

		if (!config.speed) {
			config.speed = 800;
		}

		if (config.navigation || (this.hasNextTarget && this.hasPrevTarget)) {
			Swiper.use([Navigation]);
			config.navigation = {
				nextEl: this.nextTarget,
				prevEl: this.prevTarget
			};
		}

		if (config.pagination || this.hasPaginationTarget) {
			Swiper.use([Pagination]);
			const bullets = this.paginationTarget.dataset.bullets && this.paginationTarget.dataset.bullets.length ? JSON.parse(this.paginationTarget.dataset.bullets) : [];

			config.pagination = {
				el: this.paginationTarget,
				clickable: true,
				renderBullet: function (index, className) {
					if (bullets.length) {
						return `<span class="${className}">${bullets[index]}</span>`;
					}

					let num = index + 1;
					if (index < 9) {
						num = `0${index + 1}`;
					}

					return `<span class="${className}">${num}</span>`;
				},
			};
		}

		if (config.screen) {
			if (window.screen.width < config.screen) {
				delete config.screen;
				this._swiper = new Swiper(this.element, Object.keys(config).length > 0 ? config : undefined);
			}
		} else {
			this._swiper = new Swiper(this.element, Object.keys(config).length > 0 ? config : undefined);
		}

		this.updateCurrent();

		document.addEventListener('keyup', (e) => {
			if (e.key === 'ArrowLeft' || e.keyCode === 37) {
				this._swiper.slidePrev();
			} else if (e.key === 'ArrowRight' || e.keyCode === 39) {
				this._swiper.slideNext();
			}
		});
	}

	updateCurrent() {
		if (this._swiper && this.hasCurrentCountTarget) {
			let count = this._config.slidesPerView || 1;

			this.currentCountTargets.forEach(currentCount => {
				if (this._config.breakpoints) {
					for (const [breakpoint, value] of Object.entries(this._config.breakpoints)) {
						if (window.screen.width >= parseInt(breakpoint)) {
							count = value.slidesPerView || 1;
						}
					}
				}

				count = Math.floor(count);
				currentCount.textContent = count;
			});

			this._swiper.on('slideChange', (swiper) => {
				this.currentCountTargets.forEach(currentCount => {
					currentCount.textContent = count + swiper.realIndex;
				});
			});
		}
	}

	getCurrent() {
		return this._swiper.realIndex + 1;
	}
}
